/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ProductBundles {
    "use strict";

    enum AssemblyTypeEnum {
        Assemble,
        Disassemble
    }

    import IDataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;
    
    export class ProductBundlesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        //protected searchContextCriteria:any = { };
        protected isMainTab: boolean = true;
        public skuCode: string;
        public barCode: string;        
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.baseEndpoint = appSettings.API_ENDPOINTS.productBundles; 
            this.sectionTemplatePath = 'app/plugins/productBundles/sectionViews/';
            this.entityType = 'ProductBundle';
            this.buildCrudSecurityKeys(this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MAIN);
            this.initializeSections();
          
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    'SECTION_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ProductBundleMain,
                    null,
                    this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            //if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MANAGEMENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
            //    this.sections.push(new ManagementSection(1,
            //        'SECTION_ASSEMBLE_DISASSEMBLE',
            //        'assembleDisassemble.html',
            //        false,
            //        false,
            //        this.baseEndpoint,
            //        "",
            //        this.loggingService,
            //        this.dataService,
            //        this.identityService,
            //        Meevo.Model.NounEnum.ProductBundleAssembleDisassemble,
            //        this.modalService,
            //        this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MANAGEMENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MANAGEMENT, false, false);
                    this.isMainTab = false;
                    this.showEditLogic();
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_PRODUCTBUNDLE_TAB_MAIN, true, true);
                    this.isMainTab = true;
                    super.showEditLogic();
                    break;
            }
            super.selectSection(item);
        }

        showEditLogic(): boolean {
            return this.verifySelectedSectionModel() && !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.isMainTab;
        }
        get currentBundle(): Model.ProductBundle {
            return this.castModel<Model.ProductBundle>();
        }

        addProductVariantToBundle(): void {
            var productBundle = this.currentBundle;
            if (productBundle === undefined || productBundle.variantBundle === undefined)
                return;

            if (_.find(productBundle.variantBundle !== undefined
                && productBundle.variantBundles, (vb) => {
                    return vb.displayName === productBundle.variantBundle.displayName;
                }) === undefined) {
                {
                    productBundle.variantBundle.totalRetail = productBundle.variantBundle.retail;
                    productBundle.variantBundles.push(productBundle.variantBundle);
                    productBundle.variantBundle = undefined;
                    this.calculateBundleTotalRetailPrice();
                }
            }
            else {
                this.modalService.alert("This product is already included in the bundle", 0);
            }
        }

        removeProductVariantFromBundle(index: number): void {
            var productBundle = this.currentBundle;
            if (productBundle === undefined || this.isReadonly || productBundle==null)
                return;
            productBundle.variantBundles.splice(index, 1);
            this.calculateBundleTotalRetailPrice();
        }

        calculateVariantRetailPrice(index: number): void {
            var productBundle = this.currentBundle;
            if (productBundle === undefined || this.isReadonly || productBundle == null)
                return;
            if (productBundle.variantBundles[index].quantity > 0)
                productBundle.variantBundles[index]
                    .totalRetail = productBundle.variantBundles[index].quantity *
                    productBundle.variantBundles[index].retail;
            this.calculateBundleTotalRetailPrice();
        }

        calculateBundleTotalRetailPrice() { 
            var productBundle = this.currentBundle;
            if (productBundle === undefined || this.isReadonly || productBundle == null)
                return;
            productBundle.totalBundleValue = 0;
            for (var index = 0; index < productBundle.variantBundles.length; index++){
                productBundle.totalBundleValue += productBundle.variantBundles[index].totalRetail;
            }
            this.updateBundlePrice();
        }

        updateBundlePrice() {
            var productBundle = this.currentBundle;

            if (_.isUndefined(productBundle.discountPercentage)) {
                return;
            }

            let fullPrice = productBundle.totalBundleValue - (productBundle.discountPercentage * productBundle.totalBundleValue);

            // Save price to nearest 2 decimal places for currency format
            fullPrice = Number(fullPrice.toString() + 'e2');

            productBundle.bundlePrice = Number(Math.round(fullPrice) + 'e-2');
        }

        updateDiscountPercentage() {
            let productBundle = this.currentBundle;

            if (!productBundle) {
                return;
            }

            if (productBundle.totalBundleValue === 0){
                productBundle.discountPercentage = 0;
                return;
            }

            productBundle.discountPercentage = 1 - (productBundle.bundlePrice / productBundle.totalBundleValue);
        }

        checkForUniqueSku(sku: any, model: any) {
            var variantId = Guid.empty;
            if (model != null && model != undefined && model.variants != null && model.variants!=undefined)
                variantId = model.variants[0].id;
            if (sku != null && sku != "") {
                this.dataService.customMethodData("api/Product/Variant/Validate/Sku/", "POST", { Sku: sku, variantId: variantId }).then((data) => {
                  this.selectedSection["isSkuValid"] = !data.data;
                    if (data.data) 
                        this.modalService.alert(this.$translate.instant('MESSAGE_UNIQUE_SKU', {skuCode : sku }));
                });
            }
        }
        checkForUniqueBarCode(barCode: any, model: any) {
            var variantId = Guid.empty;
            if (model != null && model != undefined && model.variants != null && model.variants != undefined)
                variantId = model.variants[0].id;
            if (barCode != null && barCode != "") {
                this.dataService.customMethodData("api/Product/Variant/Validate/BarCode/", "POST", { BarCode: barCode, variantId: variantId }).then((data) => {
                    this.selectedSection["isBarCodeValid"] = !data.data
                    if (data.data)
                        this.modalService.alert(this.$translate.instant('MESSAGE_UNIQUE_BARCODE', { barCode: barCode }));
                });
            }
        }

        copy(): void {
            if (this.canCopy) {
                this.setMode(Model.MaintenanceFormState.Copying);
                this.selectedSection.createCopy();
                this.selectedSection.model["displayName"] = "";
                this.selectedSection.model["sku"] = "";
                this.selectedSection.model["barCode"] = "";
                //this.itemId = null;
                this.postCopy();
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }
 
        save(): angular.IPromise<any> {
          
            var bundle = this.currentBundle;
            return super.save().then((res) => {
                var productBundle = this.currentBundle;
                // Save Assemble/Disassemble bundle quantity if filled in
               if (!_.isUndefined(bundle['assemblyType']) && !_.isUndefined(bundle['assemblyQuantity']) && bundle['assemblyQuantity'] > 0) {

                    let data: { assemblyTypeEnum: AssemblyTypeEnum, quantity: any, id: any } = {
                        assemblyTypeEnum: bundle['assemblyType'],
                        quantity: bundle['assemblyType'] === AssemblyTypeEnum.Assemble
                            ? (bundle['assemblyQuantity'] + ((productBundle.variants[0]['onHand'] < 0) ? Math.abs(productBundle.variants[0]['onHand']) : 0)) // if onHand of bundle is negative, will need to include as much to bring back to zero
                            : bundle['assemblyQuantity'] * (-1),
                        id: productBundle.variants[0].id
                    };
                    return this.dataService.customMethodData("api/ProductBundles/" + productBundle.id + "/Assemble", "POST", data)
                        .then((response) => {
                     
                            productBundle.variants[0]['onHand'] = response.data.variants[0].onHand;
                            return productBundle;
                        });
                }
                return productBundle;
            });          
        }

        productCriteria = {
            coSearchResultFilter: 0
        }
        getProductCriteria() {
            if (this.isApplicationModeCO) {
                return this.productCriteria;
            }
            return {};
        }

        get canEditVariantsInBundle(): boolean {
            if (this.selectedSection && this.selectedSection.model && this.currentBundle && this.currentBundle.variants && this.currentBundle.variants.length > 0 && !isNaN(this.currentBundle.variants[0].onHand)) {
                return !this.currentBundle.hasBeenSold
                    && this.currentBundle.variants[0].onHand == 0;  // only allow editing when nothing is assembled
            }
            return true;
        }

        get currentBundleOnHand(): number {
            if (this.selectedSection.model && this.currentBundle && this.currentBundle.variants && this.currentBundle.variants.length > 0 && !isNaN(this.currentBundle.variants[0].onHand)) {
                return Math.max(this.currentBundle.variants[0].onHand, 0);
            }
            return 0;
        }
    }
    
}